import { useCallback, useState } from 'react';

export const TriggerErrorScreen = () => {
  const [triggerError, setTriggerError] = useState(false);
  const handleClick = useCallback(() => {
    setTriggerError(true);
  }, []);
  if (triggerError) {
    throw new Error('Triggered an error');
  }

  return <button onClick={handleClick}>Trigger Error</button>;
};
